import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  routingNumber: () => i18n.t(i18nKeys.bankOnboarding__routingNumber),
  checkingAccountNumber: () =>
    i18n.t(i18nKeys.bankOnboarding__checkingAccountNumber),
  submit: () => i18n.t(i18nKeys.excitement__bank_account__primary_action),
  addLater: () => i18n.t(i18nKeys.excitement__bank_account__secondary_action),
  errorMessageRoutingAccount: () =>
    i18n.t(i18nKeys.bankOnboarding__errorMessageRoutingAccount),
  noBankTitle: () => i18n.t(i18nKeys.bankOnboarding__noBankModalTitle2),
  noBankContent1: () =>
    i18n.t(i18nKeys.bankOnboarding__noBankModalDasherDirect1),
  noBankContent2: () =>
    i18n.t(i18nKeys.bankOnboarding__noBankModalDasherDirect2),
  noBankButton: () => i18n.t(i18nKeys.common__gotIt),
}
